const initialState = {
  removeLogin: null,
  currentIntegrationId: null,
};

export default initialState;
